const register = (state = {}, action) => {
  switch(action.type){
    case 'ADD_REGISTER':
      return action.data;

    case 'CLEAR_REGISTER':
      return null;

    default:
      return state;
  }
}

export default register